import { render } from "./createNewPassword.vue?vue&type=template&id=1bd0c08f"
import script from "./createNewPassword.vue?vue&type=script&lang=js"
export * from "./createNewPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__